// import {  useEffect, useState } from "react";
import { useState } from 'react';

// import Mainmenu from './MainMenu';
// import LoadingDots from "./LoadingDots";

import bot from '../../assets/images/happy.png'
import Details from './Details';
// import Frame1 from './Frame1';


const Greetings = () => {
    const [time] = useState(new Date());


    const getGreeting = () => {
        const hours = time.getHours();
        if (hours < 12) return "Good Morning";
        if (hours < 18) return "Good Afternoon";
        return "Good Evening";
      };
   
    return(
        <>
        <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
            <div className="frame1 animated-frame">
            <strong>{getGreeting()}</strong>, Greetings from Agromech<br/>
            </div>
            <div className="frame1 animated-frame">
            <strong>Agromech </strong>
            Industries proudly carries forward a legacy built on 50 years of trust, quality, and innovation. What began in 1973 as a vision to deliver high-end agricultural equipment has evolved into a dynamic enterprise leading the way in kitchenware and hospitality solutions through our flagship brands—Agromech Hotel Mart, Agromech Homestore, and Kitchen Hub.
            </div>
            <Details />
        </>
    );
}
export default Greetings;   